import type { UnionOfPropertyTypes } from '@backmarket/utils/object/UnionOfPropertyTypes'

/**
 * A "payment flow" represents a specific path for completing a payment.
 * Each flow has its own payment page and logic tailored to a particular use case.
 *
 * Those ids are used to identify a payment flow across the apps.
 */
export const PaymentFlow = {
  CHECKOUT_CART: 'checkout-cart',
  /*
  CHECKOUT_INSURANCE_POST_PURCHASE: 'checkout-insurance-post-purchase',
  CARE_EXPRESS_REPLACEMENT: 'care-express-replacement',
  */
  INSURANCE_DUE_AMOUNT: 'insurance-due-amount',
  BUYBACK_SELLER_UPDATE_PAYMENT_METHOD: 'buyback-seller-update-payment-method',
} as const

export type PaymentFlow = UnionOfPropertyTypes<typeof PaymentFlow>
